import React from "react";
import { Helmet } from "react-helmet";

interface Props {
    gtmKey: string;
}

export const GoogleTagManager = ({ gtmKey }: Props) => (
    <Helmet>
        {/* 1. Google Consent Mode (BEFORE GTM) */}
        <script>
            {`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Set default consent state (all denied until Cookiebot updates)
gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'wait_for_update': 500
});

// Update consent based on Cookiebot (Usercentrics will handle this)
// Cookiebot will automatically update consent via dataLayer when user makes choices
                `}
        </script>

        {/* 2. Google Tag Manager Script (AFTER Consent Mode) */}
        <script>
            {`
{(function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', '${gtmKey}')}
                `}
        </script>
    </Helmet>
);
